import { FormOverrideAddress } from '@forms';

import {
  ContactMethod,
  CustomerEmailDetails,
  CustomerTelephoneDetails,
  DocumentSendMethod,
  removeEmptyValues,
  TitleId,
} from '@common';
import { QuotePersonInfo } from '../models/quote-person-info.interface';

export function formatEmailDetails(
  emailAddress: string | null,
): CustomerEmailDetails | undefined {
  if (!emailAddress) {
    return;
  }
  return {
    main: emailAddress,
  };
}

export function formatPreferredContactMethod(
  customerEmailAddress: string | null,
): ContactMethod {
  if (customerEmailAddress) {
    return ContactMethod.Email;
  }
  return ContactMethod.Post;
}

export function formatDocumentSendMethod(
  emailAddress: string | null,
): DocumentSendMethod {
  if (emailAddress) {
    return DocumentSendMethod.Email;
  }
  return DocumentSendMethod.Post;
}

export function formatTelephoneDetails(
  telephoneNumber: string | null,
): CustomerTelephoneDetails | undefined {
  if (!telephoneNumber) {
    return;
  }
  return {
    home: telephoneNumber,
    mobile: telephoneNumber,
  };
}

export function createQuotePersonInfo(
  firstName: string,
  surname: string,
  title: TitleId,
  selectedAddress: FormOverrideAddress,
): QuotePersonInfo {
  const cleanAddress = removeEmptyValues(
    selectedAddress,
  ) as FormOverrideAddress;
  return {
    address: {
      ...cleanAddress,
      isOverrideAddress: selectedAddress.isOverrideAddress,
    },
    firstName,
    surname,
    preference: {},
    title,
  };
}
